import React, { createContext, useContext } from "react";

const CurrencyLocaleContext = createContext();

export const useCurrencyLocale = () => useContext(CurrencyLocaleContext);

export const CurrencyLocaleProvider = ({ locale, children }) => (
  <CurrencyLocaleContext.Provider value={locale}>
    {children}
  </CurrencyLocaleContext.Provider>
);
